import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';

export class AddTeamService extends SendRequest
{
    async getUserListData(slug, params)
    {
        const url = API.client.company.USER_LIST.replace('$slug',slug);
     
        try {
             const result = await axios.get( url,
              { 
                params: params,
                headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());
            return result;
          } catch (error) {
            return error;
          }
    }

    async updateUserStatus(client_id, params)
    {
      const url = API.client.company.UPDATE_USER_STATUS.replace('$client_id', client_id);
     
      try {
           const result = await axios.put( url,
            params,
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
          return result;
        } catch (error) {
          return error;
        }
    }

    async resendInvite(client_id)
    {
      const url = API.client.company.RESENT_INVITE.replace('$client_id', client_id);
     
      try {
           const result = await axios.put( url,
            {},
            this.setHeaderJSON(),
            this.setCrossDomainTrue(),
            this.setCredentialsJSON());
          return result;
        } catch (error) {
          return error;
        }
    }

}